import React from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';

import { CustomerTable } from './CustomerTable';

const Customers = () => {
    document.title = 'Customers | MySpy';

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <h5 className="card-title mb-0">
                                        Customers
                                    </h5>
                                </CardHeader>
                                <CardBody className="pt-2">
                                    <CustomerTable />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Customers;
